import React from "react";
import Base from "../NavBar/Base";

const NodejsProjects = () => {
  return (
    <div>
      <Base />
      <span className="p-2"></span>
      <div className="container container-center">
        <ol reversed>
          <li>
            <div className="container container-center">
              <h1 className="text-primary">How well do you know Marvel?</h1>
              <small>November, 2020</small>
              <p>
                A CLI app built with <strong>NODEJS</strong>. You can send this
                to your friends and find out how well they know Marvel.
              </p>
              <button className="btn btn-warning">
                <a
                  className="link link-primary"
                  href="https://repl.it/@varunraj30/Marvel-Quiz?embed=1&output=1"
                >
                  Live Project
                </a>
              </button>
              <span className="p-2"></span>
              <button className="btn btn-danger">
                <a
                  className="link link-secondary"
                  href="https://github.com/varunraj30/Marvel-Quiz"
                >
                  View Source
                </a>
              </button>
            </div>
          </li>
          <span className="p-1"></span>
          <li>
            <div className="container container-center">
              <h1 className="text-primary">How well do you know me?</h1>
              <small>November, 2020</small>
              <p>
                A CLI app built with <strong>NODEJS</strong>. To know who know
                me well.
              </p>
              <button className="btn btn-warning">
                <a
                  className="link link-primary"
                  href="https://repl.it/@varunraj30/Know-Me?embed=1&output=1"
                >
                  Live Project
                </a>
              </button>
              <span className="p-2"></span>
              <button className="btn btn-danger">
                <a
                  className="link link-secondary"
                  href="https://github.com/varunraj30/Do-you-know-me"
                >
                  View Source
                </a>
              </button>
            </div>
          </li>
        </ol>
      </div>
      <footer className="footer position-absolute mt-auto py-2">
        <div className="container-fluid bg-success text-white text-center py-3">
          <h5>Social Media</h5>
          <a href="https://github.com/varunraj30">
            <i
              className="fa-3x p-2
          fa fa-github"
              aria-hidden="true"
            ></i>
          </a>
          <a href="https://twitter.com/varunraj3009">
            <i
              className="fa-2x p-2 
          fa fa-twitter"
              aria-hidden="true"
            ></i>
          </a>
          <a href="https://www.linkedin.com/public-profile/in/varunraj-goud-0199b115a/">
            <i
              className="fa-2x p-2 
          fa fa-linkedin"
              aria-hidden="true"
            ></i>
          </a>
          <a href="https://www.instagram.com/varunraj30/">
            <i
              className="fa-2x p-2
          fa fa-instagram"
              aria-hidden="true"
            ></i>
          </a>
          <a href="https://www.youtube.com/channel/UCUKckpYS5a6j-FchtPJt6Sg/videos">
            <i
              className="fa-2x p-2
          fa fa-youtube"
              aria-hidden="true"
            ></i>
          </a>
        </div>
      </footer>
    </div>
  );
};

export default NodejsProjects;
